import { React, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./adminLogin.css";
import Axios from "axios";
import jwtDecode from "jwt-decode";

const AdminLogin = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const handleEmailChange = (e) => {
        setUsername(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleVerification = (e) => {
        e.preventDefault();
        setSubmitDisabled(true);
        Axios.post("https://ashish.moodi.org/auth/compi_admin_login", {
            username,
            password,
        })
            .then((response) => {
                if (response.data.exists) {
                    if (response.data.authtoken) {
                        localStorage.setItem(
                            "compiauthtoken",
                            response.data.authtoken
                        );
                        window.alert("Login successfully");

                        if (
                            jwtDecode(localStorage.getItem("compiauthtoken"))
                                .user.username === "pronites"
                        ) {
                            navigate("/admin/pronites");
                        } else {
                            navigate("/admin/multicity");
                        }

                        window.location.reload();
                    } else {
                        window.alert("Invalid Password");
                    }
                } else {
                    window.alert("Invalid Credentials");
                }
            })
            .catch((error) => {
                console.error("Error verifying:", error);
            });
    };

    return (
        <>
            <h2>Login For Admin</h2>
            <div className="login-container">
                <form className="login-form" onSubmit={handleVerification}>
                    <h2>Login</h2>

                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input
                            type="text"
                            id="username"
                            name="username"
                            placeholder="Enter your username"
                            value={username}
                            onChange={handleEmailChange}
                            className="form-control"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            placeholder="Enter your password"
                            value={password}
                            onChange={handlePasswordChange}
                            className="form-control"
                        />
                    </div>
                    {submitDisabled ? (
                        <button
                            class="btn btn-primary col-auto"
                            type="submit"
                            disabled={submitDisabled}
                        >
                            <span
                                class="spinner-border spinner-border-sm"
                                aria-hidden="true"
                            ></span>
                            <span role="status">Logging In...</span>
                        </button>
                    ) : (
                        <input
                            type="submit"
                            value="Login"
                            className="btn btn-primary col-auto"
                            disabled={submitDisabled}
                        />
                    )}
                </form>
            </div>
        </>
    );
};
export default AdminLogin;
